import(/* webpackMode: "eager", webpackExports: ["LeaderboardPageSkeleton"] */ "/vercel/path0/src/features/leaderboard/components/BoardSkeleton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LeaderboardPageScreen"] */ "/vercel/path0/src/features/leaderboard/LeaderboardScreen.tsx");
